module.exports = __webpack_public_path__ + "img/icon-search-gray.a04d1bc5.svg";